import { FC } from 'react';

import InformationSection, {
  InformationSectionItem,
} from 'features/Onboarding/components/InformationSection';
import { formatAddressMultiLine } from 'helpers/address';

import locales from './locales';

interface CompanyInformationProps {
  company: {
    street: string;
    streetAddition?: string;
    city: string;
    zip: string;
    country?: string;
    legalName: string;
    tradeName: string;
  };
  onEdit?: () => void;
}
export type CompanyInformationType = FC<CompanyInformationProps>;

const CompanyInformation: CompanyInformationType = ({ company, onEdit }) => {
  const identityInformationItems: InformationSectionItem[] = [
    [locales.legalName, company.legalName],
    [locales.tradeName, company.tradeName],
    [locales.address, formatAddressMultiLine(company)],
  ];

  return (
    <InformationSection
      iconName="store"
      items={identityInformationItems}
      onEdit={onEdit}
      title={locales.identity}
    />
  );
};

export default CompanyInformation;
